import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';

const RangeActionButton = ({ className, onClick, children }) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <button
        className={classNames('button', className)}
        onClick={onClick}
        type="button"
      >
        {children}
      </button>
      <style jsx>{`
        .button {
          display: block;
          background: none;
          border: 1px solid ${theme.colors.primary};
          color: ${theme.colors.primary};
          border-radius: 4px;
          padding: 3px 20px;
          font-size: 16px;
          margin-bottom: 20px;
          text-transform: uppercase;
        }
        .button.no-margin {
          margin: 0;
        }
        .button.center {
          margin-left: auto;
          margin-right: auto;
        }
      `}</style>
    </>
  );
};

RangeActionButton.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default RangeActionButton;
